module.exports = "/fonts/vendor/mavon-editor/dist/fontello.woff2?eeaa6471a0be8b943c195839b3964c9e";